// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"24":"63232a95","103":"4ed91407","192":"2bef0edd","418":"eb40c9d4","494":"7b2d10c9","523":"6ad40f68","555":"bf723f72","751":"0686e65b","787":"d412c04a","937":"9b47ce46"}[chunkId] + ".chunk.js";
};